import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

export default function CrmPipelineChart({ pipelineData }) {
  return (
    <Paper sx={{ p: 3, height: 340 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Pipeline by Stage
      </Typography>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={pipelineData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" allowDecimals={false} />
          <YAxis dataKey="stage" type="category" width={120} />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#1976d2" name="Deals" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
